import { Component, Input, inject } from '@angular/core';
import { IResource } from '@app/core/contracts/dto';
import { ContentType } from '@app/core/enums/content-type.enum';
import { ModalController } from '@ionic/angular';
import { LinkTarget, pdfDefaultOptions } from 'ngx-extended-pdf-viewer';

@Component({
    selector: 'app-resource-viewer',
    templateUrl: './resource-viewer.component.html',
    styleUrls: ['./resource-viewer.component.scss'],
    standalone: false
})
export class ResourceViewerComponent {
  private modalController = inject(ModalController);

  @Input() resource: IResource;
  contentType = ContentType;

  constructor() {
    pdfDefaultOptions.externalLinkTarget = LinkTarget.BLANK;
  }

  back() {
    this.modalController.dismiss();
  }
}
